import { twMerge } from '@panwds/tailwindcss';
export const bottomNavV3Classes = {
    ul: {
        boxSizing: 'twds-box-border',
        list: 'twds-list-none',
        spacing: 'twds-m-0 twds-p-0'
    }
};
export function getBottomNavListClasses(className) {
    return twMerge(bottomNavV3Classes.ul.boxSizing, bottomNavV3Classes.ul.list, bottomNavV3Classes.ul.spacing, className);
}
//# sourceMappingURL=bottomNav.logic.js.map